export default __webpack_public_path__ + "static/media/Content3.38fe1e1b.png";